import { validateEmailI18n, validateRequiredI18n } from 'utils';
import { validateCompose } from '../../../common/utils/validation';

export const validateForgotPassword = validateCompose(validateRequiredI18n, validateEmailI18n);
